Monitoring.Views ||= {}

class Monitoring.Views.ReviewQueueDefinitionGeneralEditView extends Backbone.View
  template: JST["backbone/templates/moderation/review_queue_definitions/review_queue_definition_general_edit"]
  events:
    'change #review_queue_definitions-name'          : 'onChangeName'
    'change #review_queue_definitions-active'        : 'onChangeActive'
    'change #review_queue_definitions-supervision'   : 'onChangeSupervision'
    'change #automatic-priority'                     : 'onChangePriority'
    'change #review_queue_definitions-reverse_order' : 'onChangeOrder'

  initialize: (@options = {}) ->
    @reviewQueueDefinition = @options.reviewQueueDefinition
    @availableUsers = @options.availableUsers
    @availableUsersGroups = @options.availableUsersGroups
    @relatedUsersConnector = new Monitoring.Views.RelatedUsersConnectorView(
      @reviewQueueDefinition.get('granted_entities'),
      @availableUsers,
      @availableUsersGroups
    )
    @listenTo(@relatedUsersConnector, 'onChange', @onChangePermissions)

  render: =>
    @$el.html(@template(@))
    @initializeToggle()
    @$el.find('#review_queue_definitions-permissions').html(@relatedUsersConnector.render().el)
    @$el.find('#automatic-priority').simpleSlider(
      range: [1, 10], snap: true, step: 1
    ).bind('slider:changed', (e, data) => @$el.find('#priority-number').text(data.value));
    @

  initializeToggle: ->
    @$el.find('#review_queue_definitions-active').bootstrapToggle({})
    @$el.find('#review_queue_definitions-supervision').bootstrapToggle({})
    @$el.find('#review_queue_definitions-reverse_order').bootstrapToggle({ width: 50 })

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @trigger('changed-mandatory-field')

  onChangeActive: (evt) =>
    @reviewQueueDefinition.set('active', @$el.find('#review_queue_definitions-active').prop('checked'))

  onChangeSupervision: (evt) =>
    @reviewQueueDefinition.set('supervision', @$el.find('#review_queue_definitions-supervision').prop('checked'))

  onChangePriority: (evt) =>
    @reviewQueueDefinition.set('priority', @$el.find('#automatic-priority').val())

  onChangeOrder: (evt) =>
    @reviewQueueDefinition.set('reverse_order', @$el.find('#review_queue_definitions-reverse_order').prop('checked'))

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#review_queue_definitions-#{propertyName.replace('_', '-')}").val().trim()
    @reviewQueueDefinition.set(propertyName, enteredProperty)

  onChangePermissions: (relatedUsersConnector) =>
    @reviewQueueDefinition.set('granted_entities', relatedUsersConnector)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled()

  nameIsFilled: ->
    @$el.find('#review_queue_definitions-name').val().trim().length > 0